import { render, staticRenderFns } from "./ListaConfigUser.vue?vue&type=template&id=cef2ae72&"
import script from "./ListaConfigUser.vue?vue&type=script&lang=js&"
export * from "./ListaConfigUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports